interface CookieOptions {
  days?: number;
  path?: string;
  domain?: string;
  sameSite?: "Lax" | "Strict" | "None";
}

class CookieManager {
  static set(name: string, value: string, options: CookieOptions = {}): void {
    const { days = 7, path = "/", domain, sameSite = "Lax" } = options;

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookieString += `; expires=${date.toUTCString()}`;
    }

    cookieString += `; path=${path}`;
    if (domain) cookieString += `; domain=${domain}`;
    if (sameSite) cookieString += `; samesite=${sameSite}`;

    if (
      typeof window !== "undefined" &&
      window.location.protocol === "https:"
    ) {
      cookieString += `; secure`;
    }

    document.cookie = cookieString;
  }

  static get(name: string): string | null {
    if (typeof document === "undefined") return null;
    const nameEQ = encodeURIComponent(name) + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }

  /**
   * Checks if a cookie exists by name.
   */
  static exists(name: string): boolean {
    return this.get(name) !== null;
  }

  static delete(name: string, path: string = "/"): void {
    this.set(name, "", { days: -1, path });
  }
}

export default CookieManager;
